import React from "react";
import { useSelector } from "react-redux";
import { Dropdown, Icon } from "semantic-ui-react";
import useTheme from "../../../../hooks/useTheme";
import { getAllSwedentLocationTranslation } from "../../../../utils/helperFunctions";
import { AppPrimaryButton, PrimaryChip } from "../../../UI/CustomButtons";
import { AppColumn, AppRow, Wrap } from "../../../UI/Layouts";
import { SizedBox } from "../../../UI/Sizes";
import AppText from "../../../UI/Texts/AppTexts";
import UserActions from "../../../../utils/Constants/UserActions";
import { t } from "i18next";
import { useResponsive } from "../../../UI/ResponsiveContext";

const LocationSelectionSection = ({
  formData,
  updateFormData,
  onNext,
  onBack,
}) => {

  const { isMobile } = useResponsive()
  const theme = useTheme();

  const core = useSelector((state) => state.core);
  const coreConstants = Object.freeze(core.constants);

  const jobLocations = (coreConstants.appLocations ?? []).sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  const locationOptions = jobLocations.map((location) => {
    return {
      key: location.key,
      value: location.key,
      text: location.name,
    };
  });

  const suggestedLocations = (coreConstants.suggestedLocations ?? []).map((location) => {
    return {
      key: location,
      value: location,
      text: location === "all_sweden" ? getAllSwedentLocationTranslation() : location,
    };
  }).filter((e) => !(formData.locations ?? []).includes(e.value));


  const handleSuggestedLocationClick = (e, { value }) => {

    if (!formData.locations.includes(value)) {
      updateFormData("locations", [...formData.locations, value]);
    }
  };

  const handleRemoveLocation = (location) => {
    updateFormData(
      "locations",
      formData.locations.filter((l) => l !== location)
    );
  };

  return (

    <AppColumn>
      <AppRow mainAxisAlignment={'space-between'} crossAxisAlignment={'center'}>

        <AppText.HeadingBig className={'text-headline'} fontWeight={600}>
          {t('registration.select_location.title')}
        </AppText.HeadingBig >

        <AppPrimaryButton
          userActionKey={UserActions.select_locations}
          size={'large'}
          onClick={onNext}
          style={{
            borderRadius: theme.radius.small,
          }}>
          {t('next')}
        </AppPrimaryButton>
      </AppRow>
      <SizedBox height={theme.spacing.contentPadding} />
      <AppRow crossAxisAlignment={'center'}>
        <Icon name="map marker alternate" color={theme.primaryColor} style={{
          color: theme.primaryColor,
        }} />
        <AppText.Footnote>
          {t('registration.select_location.description')}
        </AppText.Footnote>
      </AppRow>
      <SizedBox height={theme.spacing.elementPadding} />

      <Dropdown
        placeholder={t('registration.select_location.dropdown.placeholder')}
        fluid
        selection
        search
        options={locationOptions}
        onChange={handleSuggestedLocationClick}
        style={{
          padding: theme.spacing.elementPadding,
          marginBottom: theme.spacing.contentElementPadding,
        }}
        className="custom-height-dropdown"
      />

      {suggestedLocations.length > 0 && <AppColumn>
        <AppText.Caption>{t('registration.select_location.suggested_locations')}</AppText.Caption>
        <SizedBox height={theme.spacing.elementPadding} />
        <Wrap>
          {suggestedLocations.map((location, index) => {
            return (
              <PrimaryChip
                key={index}
                secondary
                small={isMobile}
                onClick={(e) => handleSuggestedLocationClick('', { value: location.value })}
                text={location.text}
              />
            );
          })}
        </Wrap>
        <SizedBox height={theme.spacing.contentElementPadding} />
      </AppColumn>}
      {formData.locations.length > 0 && (<AppColumn>
        <AppText.Caption>{t('registration.selected_location.title')}</AppText.Caption>
        <SizedBox height={theme.spacing.elementPadding} />
        <Wrap>
          {(formData.locations ?? []).map((location, index) => {
            const locationText = locationOptions.find((e) => e.key === location).text;

            return (
              <PrimaryChip
                small={isMobile}
                key={index}
                text={locationText}
                onRemove={() => handleRemoveLocation(location)} />
            );
          })}
        </Wrap>

      </AppColumn>)}



    </AppColumn>

  );
};

export default LocationSelectionSection;
